import { AuthService } from '../../features/auth/auth.service'
import { Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'

@Injectable()
export class MirrorPoliciesGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate(): boolean {
    // Proposta de seguro é documento interno: só o acesso master enxerga.
    if (this.authService.isMasterAccess()) {
      return true
    }

    this.router.navigate(['/dashboard'])
    return false
  }
}
